import(/* webpackMode: "eager", webpackExports: ["UkeplanKalkulator"] */ "/vercel/path0/app/ukeplan-kalkulator/UkeplanKalkulator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareBar"] */ "/vercel/path0/components/shared/ShareBar.tsx");
